module.exports = __webpack_public_path__ + "img/tick.ae8300f8.svg";